import { type ComponentPropsWithoutRef, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type FileStatusTitleProps = ComponentPropsWithoutRef<'h6'>;

export const FileStatusTitle = memo(({ className, ...restOfProps }: FileStatusTitleProps) => (
  <h6
    className={cn('mb-0.5 truncate font-semibold ads:text-primary text-14 text-gray-12', className)}
    {...restOfProps}
  />
));

FileStatusTitle.displayName = 'FileStatusTitle';
